import { paths } from '@mc/paths'
import { track, getPageSource } from '@mc/track-event'

import { AnyCourse } from './types'

// Event Types
const TRAILER_MODAL_CLICK = 'Trailer Modal Click'
const TRAILER_MODAL_DISMISSED = 'Trailer Modal Dismissed'
const TRAILER_MODAL_VIEWED = 'Trailer Modal Viewed'

// Actions
const VIEW_CLASS = 'View Class'

// Locations
export const GROWTH_TRAILER_MODAL = 'growth_trailer_modal'

// Helpers
const getPagePath = () =>
  typeof window !== 'undefined' ? window.location.pathname : ''

const getCourseType = (course: AnyCourse) =>
  'type' in course ? course.type : 'camp'

// Event trackers

export const trackTrailerModalViewed = ({
  courseSlug,
  location = GROWTH_TRAILER_MODAL,
}: {
  courseSlug?: string
  location?: string
}) => {
  track(TRAILER_MODAL_VIEWED, {
    location,
    page_source: getPageSource(),
    class: courseSlug,
    page_path: getPagePath(),
  })
}

export const trackTrailerModalClose = ({
  course,
  action = 'clicked-outside',
}: {
  course: AnyCourse
  action?: 'clicked-outside' | 'clicked-x'
}) => {
  track(TRAILER_MODAL_DISMISSED, {
    action,
    page_source: getPageSource(),
    class: course.slug,
  })
}

export const trackViewClassClick = ({ course }: { course: AnyCourse }) => {
  track(TRAILER_MODAL_CLICK, {
    page_path: paths.courseTypePage(getCourseType(course), course.slug),
    action: VIEW_CLASS,
    page_source: getPageSource(),
    class: course.slug,
  })
}
